/**
 * Hero 360 Slider Block JavaScript
 */

(function() {
    'use strict';

    function initHero360Slider() {
        const startBtn = document.getElementById('start-btn');
        const slot = document.getElementById('slot');
        if (!startBtn || !slot) return;

        const items = slot.getElementsByTagName('li');
        if (items.length === 0) return;

        const slotHeight = items[0].offsetHeight;
        let currentPosition = 0;

        function spin() {
            const spins = Math.floor(Math.random() * 5) + 3;
            currentPosition -= spins * slotHeight;
            slot.style.top = currentPosition + 'px';

            setTimeout(function() {
                for (let i = 0; i < spins; i++) {
                    slot.appendChild(slot.firstElementChild);
                }
                slot.style.transition = 'none';
                slot.style.top = '0';
                slot.offsetHeight;
                slot.style.transition = 'top 1s ease-out';

                const selectedItem = slot.firstElementChild.querySelector('a');
                const linkBtn = document.querySelector('#link-btn');
                if (selectedItem && linkBtn) {
                    linkBtn.setAttribute('href', selectedItem.getAttribute('href'));
                    linkBtn.innerHTML = selectedItem.getAttribute('title');
                }
            }, 1000);
        }

        startBtn.addEventListener('click', spin);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHero360Slider);
    } else {
        initHero360Slider();
    }
})();
